// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__rE1Hh","main":"Layout_main__YKNuE"};